// extracted by css-extract-rspack-plugin
export default {"pill":"pill-vfHzns","danger":"danger-LnoE_W","warning":"warning-xF9dD2","success":"success-IiVOad","neutral":"neutral-DrnGR4","default":"default-GTLdNR"};